import React from "react";

/**
 * EDS ELECTROMENAGER logo.
 * variant="dark"  -> for light backgrounds (default, used in header)
 * variant="light" -> for dark backgrounds (used in footer)
 * size="sm" | "md" | "lg"
 */
const Logo = ({ variant = "dark", size = "md", showTagline = true }) => {
  const isDark = variant === "dark";
  const primary = isDark ? "#0b2960" : "#ffffff";
  const accent = "#e11d24";
  const muted = isDark ? "#64748b" : "rgba(255,255,255,0.75)";

  const sizes = {
    sm: { icon: 32, title: "text-base", sub: "text-[9px]" },
    md: { icon: 42, title: "text-xl", sub: "text-[10px]" },
    lg: { icon: 56, title: "text-3xl", sub: "text-xs" },
  }[size] || { icon: 42, title: "text-xl", sub: "text-[10px]" };

  return (
    <div className="flex items-center gap-3 select-none">
      {/* Icon mark - shield with lightning */}
      <div className="relative shrink-0" style={{ width: sizes.icon, height: sizes.icon }}>
        <svg viewBox="0 0 64 64" width={sizes.icon} height={sizes.icon} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="logo-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={primary} />
              <stop offset="100%" stopColor={isDark ? "#1a3f8a" : "#f1f5f9"} />
            </linearGradient>
          </defs>
          {/* Shield background */}
          <path
            d="M32 2 L58 12 L58 30 C58 46 48 58 32 62 C16 58 6 46 6 30 L6 12 Z"
            fill="url(#logo-grad)"
            stroke={accent}
            strokeWidth="2"
          />
          {/* Lightning bolt (accent) */}
          <path
            d="M34 14 L20 36 L30 36 L26 50 L44 26 L34 26 Z"
            fill={accent}
            stroke="#ffffff"
            strokeWidth="1"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Word mark */}
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline gap-1.5">
          <span
            className={`${sizes.title} font-black tracking-tight`}
            style={{
              color: primary,
              fontFamily: "'Poppins', 'Inter', sans-serif",
              letterSpacing: "-0.02em",
            }}
          >
            EDS
          </span>
          <span
            className={`${sizes.title} font-light tracking-wide`}
            style={{
              color: isDark ? "#334155" : "rgba(255,255,255,0.92)",
              fontFamily: "'Poppins', 'Inter', sans-serif",
              letterSpacing: "0.01em",
            }}
          >
            ELECTROMENAGER
          </span>
        </div>
        {showTagline && (
          <div
            className={`${sizes.sub} font-semibold tracking-[0.22em] uppercase mt-1.5 flex items-center gap-1.5`}
            style={{ color: muted }}
          >
            <span className="h-px w-4" style={{ backgroundColor: accent }} />
            Dépannage · Service · Marseille
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
